import { bool, number, object, ref, string } from 'yup';
import { get } from 'lodash';
import { FormikValues } from 'formik';
import { Content } from 'api';

const networkSchema = (requireText: boolean) => {
  let userCommentaryValidator = string().max(ref('limit'));
  if (requireText) {
    userCommentaryValidator = userCommentaryValidator.required();
  }
  return object().shape({
    active: bool(),
    limit: number().nullable(true),
    network_id: string().nullable(true),
    user_commentary: string().when('active', {
      is: true,
      then: userCommentaryValidator,
      otherwise: string(),
    }),
  });
};

const SharingSchema = (initialValues?: FormikValues, content?: Content) => {
  const requireText = !hasImageOrLink(content);
  return object()
    .shape({
      content_id: string().required(),
      share_type: string().required(),
      share_at: number().nullable(true),
      facebook: networkSchema(requireText),
      twitter: networkSchema(requireText),
      linkedin: networkSchema(requireText),
    })
    .test('has-active-network', 'REQUIRED MESSAGE', (values: FormikValues) => {
      const activeValues = initialValues || values;
      return (
        get(activeValues, 'twitter.active') ||
        get(activeValues, 'linkedin.active') ||
        get(activeValues, 'facebook.active')
      );
    })
    .test('has-active-network', 'REQUIRED MESSAGE', (values: FormikValues) => {
      const activeValues = initialValues || values;
      return (
        get(activeValues, 'twitter.active') ||
        get(activeValues, 'linkedin.active') ||
        get(activeValues, 'facebook.active')
      );
    });
};

const hasImageOrLink = (content?: Content) => {
  if (!content) {
    return false;
  }
  const { content_object } = content;
  return !!(content_object.photos?.length || content_object.url);
};

const ExternalSharingSchema = object()
  .shape({
    share_type: string().required(),
    share_at: number().nullable(true),
    facebook: networkSchema(false),
    twitter: networkSchema(false),
    linkedin: networkSchema(false),
  })
  .test('has-active-network', 'REQUIRED MESSAGE', (values: FormikValues) => {
    return (
      get(values, 'twitter.active') ||
      get(values, 'linkedin.active') ||
      get(values, 'facebook.active')
    );
  });

export { SharingSchema, ExternalSharingSchema };
